// Loading Dashmix Boostrap here loads it twice, see ./exa_modules/consultant-activities.js
// require('./dashmix/bootstrap');

require('./bootstrap');

require('./exapoint');

require('./chat');

require('./menu_responsive')
